import React, { useState } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import axios from 'axios';
import { API_URL } from '../utils/api';

const PartnerRequestButton = ({ userId, onRequestSent }) => {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  const handleRequest = async () => {
    try {
      setLoading(true);
      await axios.post(`${API_URL}/api/users/partner-request/${userId}`);
      setNotification({
        open: true,
        message: 'Partner request sent successfully!',
        severity: 'success'
      });
      if (onRequestSent) onRequestSent();
    } catch (error) {
      setNotification({
        open: true,
        message: error.response?.data?.message || 'Failed to send partner request',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<FavoriteIcon />}
        onClick={handleRequest}
        disabled={loading}
        sx={{
          background: 'linear-gradient(90deg,var(--gradient-start),var(--gradient-end))',
          boxShadow: 'var(--elevation-2)',
          color: 'white',
          '&:hover': { transform: 'translateY(-2px)', filter: 'brightness(0.98)' },
          textTransform: 'none'
        }}
      >
        {loading ? 'Sending...' : 'Send Partner Request'}
      </Button>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PartnerRequestButton; 